<template>
  <a-card :bordered="false">
    <div class="table-page-search-wrapper">
      <a-form layout="inline" @keyup.enter.native="searchQuery">
        <a-row :gutter="12">
          <a-col :md="7" :sm="8">
            <a-form-item label="UserID" :labelCol="{ span: 6 }" :wrapperCol="{ span: 14, offset: 1 }">
              <a-input placeholder="Please enterUserID" v-model="queryParam.orderInfoId"></a-input>
            </a-form-item>
          </a-col>
          <a-col :md="7" :sm="8">
            <a-form-item label="User Name" :labelCol="{ span: 6 }" :wrapperCol="{ span: 14, offset: 1 }">
              <a-input placeholder="Please enterUser Name" v-model="queryParam.userName"></a-input>
            </a-form-item>
          </a-col>
          <a-col :md="7" :sm="8">
            <a-form-item label="User Phone" :labelCol="{ span: 6 }" :wrapperCol="{ span: 14, offset: 1 }">
              <a-input placeholder="Please enterUser Phone" v-model="queryParam.userPhone"></a-input>
            </a-form-item>
          </a-col>
          <!-- <a-col :md="7" :sm="8">
            <a-form-item label="CustomerPhone" :labelCol="{ span: 6 }" :wrapperCol="{ span: 14, offset: 1 }">
              <a-input placeholder="Please enterCustomerPhone" v-model="queryParam.phone"></a-input>
            </a-form-item>
          </a-col>
          <a-col :md="7" :sm="8">
            <a-form-item label="OrderInfoID" :labelCol="{ span: 6 }" :wrapperCol="{ span: 14, offset: 1 }">
              <a-input placeholder="Please enterOrderInfoID" v-model="queryParam.orderInfoId"></a-input>
            </a-form-item>
          </a-col> -->

          <a-col :md="7" :sm="8">
            <span style="float: left; overflow: hidden" class="table-page-search-submitButtons">
              <a-button type="primary" @click="searchQuery" icon="search">Search</a-button>
              <a-button type="primary" @click="searchReset" icon="reload" style="margin-left: 8px">Reset</a-button>
            </span>
          </a-col>
        </a-row>
      </a-form>

      <a-table
        ref="table"
        rowKey="id"
        size="middle"
        :columns="columns"
        :dataSource="dataSource"
        :pagination="ipagination"
        :loading="loading"
        :scroll="{ x: 1400 }"
        bordered
        @change="handleTableChange"
      >
        <span slot="recordUrl" slot-scope="text">
          <a v-if="text" :href="text" target="_blank">{{ text }}</a>
          <span v-else>-</span>
        </span>
        <span slot="direction" slot-scope="text">
          <span v-if="text === 0 || text === '0'">Outbound</span>
          <span v-else-if="text === 1 || text === '1'">Inbound</span>
          <span v-else>-</span>
        </span>
        <span slot="through" slot-scope="text">
          <span v-if="text === true || text === 'true' || text === 1 || text === '1'">Connected</span>
          <span v-else-if="text === false || text === 'false' || text === 0 || text === '0'">Not Connected</span>
          <span v-else>-</span>
        </span>
      </a-table>
    </div>
  </a-card>
</template>

<script>
import { filterObj } from '@/utils/util'
import { getCallRecords } from '@/webpublicapi/system'

export default {
  name: 'CallRecord',
  data() {
    return {
      // Pagination params
      ipagination: {
        current: 1,
        pageSize: 10,
        pageSizeOptions: ['10'],
        showTotal: (total, range) => {
          return range[0] + '-' + range[1] + ' Total ' + total + ' records'
        },
        showQuickJumper: true,
        showSizeChanger: false,
        total: 0,
      },
      dataSource: [],
      // Query conditions
      queryParam: {
        zxUserId: '',
        userName: '',
        userPhone: '',
      },
      loading: false,
      // Table header
      columns: [
        // { title: 'UserID', align: 'left', dataIndex: 'userId', width: '120px' },
        { title: 'Yunke User Name', align: 'left', dataIndex: 'userName', width: '120px' },
        { title: 'User Phone', align: 'left', dataIndex: 'userPhone', width: '110px' },
        { title: 'ConversationTime', align: 'left', dataIndex: 'createTime', width: '150px' },
        { title: 'CustomerPhone', align: 'left', dataIndex: 'phone', width: '100px' },
        { title: 'ConversationWhenLong', align: 'left', dataIndex: 'duration', width: '50px' },
        {
          title: 'RecordingAddress',
          align: 'left',
          dataIndex: 'recordUrl',
          width: '160px',
          scopedSlots: { customRender: 'recordUrl' },
        },
        {
          title: 'Outbound/Inbound',
          align: 'left',
          dataIndex: 'direction',
          width: '80px',
          scopedSlots: { customRender: 'direction' },
        },
        {
          title: 'Whether Answered',
          align: 'left',
          dataIndex: 'through',
          width: '70px',
          scopedSlots: { customRender: 'through' },
        },
        { title: 'Employee Outbound Call SIM Card ICCID', align: 'left', dataIndex: 'simNumber', width: '140px' },
        { title: 'System User ID', align: 'left', dataIndex: 'zxUserId', width: '140px' },
        { title: 'TaskID', align: 'left', dataIndex: 'taskId', width: '140px' },
        { title: 'OrderInfoID', align: 'left', dataIndex: 'orderInfoId', width: '140px' },
      ],
      isorter: {
        column: 'createTime',
        order: 'desc',
      },
    }
  },
  created() {
    this.loadData(true)
  },
  methods: {
    // Query
    async searchQuery() {
      // Reset to first page
      this.ipagination.current = 1

      this.loading = true
      const param = {
        pageNum: this.ipagination.current,
        pageSize: this.ipagination.pageSize,
        userId: this.queryParam.orderInfoId ? this.queryParam.orderInfoId : undefined,
        userName: this.queryParam.userName ? this.queryParam.userName : undefined,
        userPhone: this.queryParam.userPhone ? this.queryParam.userPhone : undefined,
      }

      try {
        const res = await this.getCallRecords(param)
        const ok = res && (res.code === 1000 || res.code === 0)
        if (!ok) {
          this.ipagination.total = 0
          this.dataSource = []
          const msg = res && res.msg ? res.msg : 'Query failed'
          this.$message.error(msg)
          return
        }

        const data = res.data || {}
        const rows = data.rows || data.list || []
        let total = 0
        if (typeof data.total === 'number') {
          total = data.total
        } else if (Array.isArray(data.list)) {
          total = data.list.length
        }

        this.ipagination.total = total
        this.dataSource = rows
      } catch (e) {
        this.ipagination.total = 0
        this.dataSource = []
        this.$message.error(e.message || 'Query failed')
      } finally {
        this.loading = false
      }
    },
    getCallRecords(param) {
      return getCallRecords(param)
    },
    // Reset
    searchReset() {
      this.resetQueryParam()
      this.loadData(true)
    },
    // List loading
    async loadData(resetPage = false) {
      if (resetPage) {
        this.ipagination.current = 1
      }

      this.loading = true
      const params = this.getQueryParams()

      try {
        const res = await getCallRecords(params)
        const ok = res && (res.code === 1000 || res.code === 0)
        if (!ok) {
          this.ipagination.total = 0
          this.dataSource = []
          const msg = res && res.msg ? res.msg : 'Query failed'
          this.$message.error(msg)
          return
        }

        const data = res.data || {}
        const rows = data.rows || data.list || []
        let total = 0
        if (typeof data.total === 'number') {
          total = data.total
        } else if (Array.isArray(data.list)) {
          total = data.list.length
        }

        this.ipagination.total = total
        this.dataSource = rows
      } catch (e) {
        this.$message.error(e.message)
      } finally {
        this.loading = false
      }
    },
    getQueryParams() {
      const param = {
        pageNum: this.ipagination.current,
        pageSize: this.ipagination.pageSize,
        // userId: 0,
        // userName: '',
        // userPhone: '',
      }
      return filterObj(param)
    },
    handleTableChange(pagination) {
      this.ipagination.current = pagination.current
      this.ipagination.pageSize = pagination.pageSize
      //   this.loadData()
      this.searchQuery()
    },
    resetQueryParam() {
      this.queryParam = {
        userName: '',
        userPhone: '',
        phone: '',
        orderInfoId: '',
      }
    },
  },
}
</script>

<style lang="less" scoped>
@import '~@/assets/less/common.less';
</style>
